import { useCallback, useState } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import {
  useGetNumUnreadNotificationsQuery,
  useListNotificationsQuery
} from '../../redux/api/notificationApi'

export const NOTIFICATION_PAGE_SIZE = 150

export const useGetNotifications = () => {
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const [end, setEnd] = useState<Date>()
  const [notificationAnchorEl, setNotificationAnchorEl] =
    useState<HTMLElement | null>(null)
  const {
    data: notifications,
    isLoading,
    isFetching,
    refetch
  } = useListNotificationsQuery(
    {
      authorization: accessToken,
      shop: shopId,
      startDateInclusive: '1970-01-01T00:00:00.000Z',
      endDateExclusive: end ? end.toISOString() : undefined,
      numResults: NOTIFICATION_PAGE_SIZE
    },
    { pollingInterval: 60000 }
  )
  const {
    data: numUnreadNotifications,
    isLoading: loadingUnreadNotification,
    isFetching: fetchingUnreadNotification,
    refetch: refetchUnreadNotification
  } = useGetNumUnreadNotificationsQuery(
    {
      authorization: accessToken,
      shop: shopId
    },
    { pollingInterval: 60000 }
  )

  const loadingNotifications = isLoading || loadingUnreadNotification
  const fetchingNotifications = isFetching || fetchingUnreadNotification
  const refetchNotifications = useCallback(() => {
    refetch()
    refetchUnreadNotification()
  }, [refetch, refetchUnreadNotification])

  return {
    notifications,
    numUnreadNotifications,
    loadingNotifications,
    setNotificationEndTime: setEnd,
    notificationAnchorEl,
    setNotificationAnchorEl,
    fetchingNotifications,
    refetchNotifications
  }
}
